<template>
	<div class="admin_wrap">
		<div class="container">
			<div class="header">
				<div class="title">
		            <div class="logo"><img src="../images/logo.png" class="g_full_img"></div>
		            <div class="titleTxt">
		                <ul class="clearfix">
		                	<li v-for="value in nav" @mouseenter="value.isShow=true" @mouseleave="value.isShow=false">
		                		<a class="menu" href="javascript:;" @click="toMenu(value)">{{value.parenttitle}}</a>
		                		<div class="listchild" v-show="value.isShow">
		                			<ul class="submenu">
		                				<li class="listlist" v-for="(child, index) in value.childtitle">
		                					<a href="javascript:;" @click="toSubMenu(value, child, index)">{{child}}</a>
		                				</li>
		                			</ul>
		                		</div>
		                	</li>
		                </ul>
		            </div>
		        </div>
			</div>
		    <img src="../images/img1.png" class="g_full_img">
	    </div>
		<router-view></router-view>
		<div class="footer">
	        <div class="container">
	        	<div class="con clearfix">
        			<div>
		                <p class="p1">电话：（020）38361478、38289993、38258319、38289551</p>
		                <p class="p2">传真：（020）38289551</p>
		                <p class="p3">邮箱：gzsahuiyuan@qq.com</p>
		                <p class="p4">地址：广州市天河区软件路13号天河人才港7楼711室</p>
		            </div>
	        		<div style="padding-left: 60px;">
	        			<p class="p5">协会会员QQ群：68777590</p>
		                <p class="p5">协会税收QQ群：1018365645</p>
		                <p class="p5">行业税收QQ群：365092068</p>
	        		</div>
		            <!-- <div class="description">
		            	<p>广州市软件行业协会成立于2000年3月，是广州地区从事软件研究、生产的企业自愿组成的唯一5A级行业性社团组织和枢纽型社会组织，自2006年完成民间化整改以来，协会搭建起以会员大会、常务理事会、秘书处为主体的良好体制、机制平台，并不断吸纳广州骨干软件企业加入，自2006年完成民间化整改以来，协会搭建起以会员大会、常务理事会、秘书处为主体的良好体制、机制平台，并不断吸纳广州骨干软件企业加入，目前协会有常务理事单位59家，囊括行业各领域龙头企业，形成了一支强有力的常务理事队伍，同时，协会会员累计819家，每年协会通过政策宣讲、行业对接、资质认定、科技金融等各项业务，服务的企业超过1200家，累积了丰富的行业资源。</p>
		            	<a href="http://www.miitbeian.gov.cn" target="_blank" class="beian" style="display: inline-block; padding-top: 20px; font-size: 16px; color: white;"></a>备案号：粤ICP备18124251号</p>
		            </div> -->
		            <img src="../images/qrcode.png" class="img" alt="">
	        	</div>
	        </div>
        	<div class="container des">
        		<span>备案号：粤ICP备18124251号</span>
        		<span style="padding-left: 100px;">Copyright 2020 all by 广州市软件行业协会</span>
            	<!-- <span class="logofoot"></span> -->
        	</div>
	    </div>
	    <!-- <div class="listRig">
            <ul>
            	<li
            		:class="floatClass[index]"
            		@click="toFriendLink(list.link)"
            		v-for="(list, index) in floatList">{{list.title}}</li>
            </ul>
        </div> -->
        <Load></Load>
	</div>
</template>
<script>
	require('../css/style.css')
	import Load from '@/components/Load.vue'
	export default {
		components: { Load },
		created() {
			this.getHeadList();
			// this.getFloatBannerList();
			this.addLog('signin');
		},
		data() {
			return {
				nav: [],
				floatList: '',
				floatClass: ['service', 'attend', 'company']
			}
		},
		methods: {
			linkTo(path) {
				window.sessionStorage.setItem('top', '1');
				this.$router.go({path: path});
			},
			async getHeadList() {
				let res = await this.$api.base.getHeadList();

				res.repBody.push({
					child: '',
					childtitle: '',
					parent_id: '0',
					parenttitle: '网站首页'
				});
				res.repBody.forEach(value => {
					value['isShow'] = false;
					if (value.parent_id != '0') {
						value.child = value.child.replace(/\[|\]/g, '').split(',');
						value.childtitle = value.childtitle.replace(/\[|\]/g, '').split(',');
					}
				})

				window.sessionStorage.setItem('nav', window.JSON.stringify(res.repBody));

				this.nav = res.repBody;
			},
			async getFloatBannerList() {
				let res = await this.$api.base.getFloatBannerList();

				this.floatList = res.repBody;
			},
			/**
			 * 数据统计
			 */
			addLog(type,button_name) {
				try {
					this.$api.base.addAcceptLog({
						ip: returnCitySN.cip,
						type: type,
						button_name: button_name,
						ip_source: returnCitySN.cname,
						source: 'pc'
					})
				} catch(e) {

				}	
			},
			/**
			 * 跳转到一级菜单
			 * @Author chenweibiao
			 * @param  {[type]}    data [description]
			 * @return {[type]}
			 */
			toMenu(data) {

				this.addLog('button', data.parenttitle + '#1');

				if (data.parent_id === '0') {
					this.$router.replace({
						name: 'Home'
					})
				} else {
					this.$router.push({
						name: 'Detail1',
						params: {
							firstId: data.parent_id
						}
					})
				}
			},
			/**
			 * 跳转到二级菜单
			 * @Author chenweibiao
			 * @param  {[type]}    data  [description]
			 * @param  {[type]}    child [description]
			 * @param  {[type]}    index [description]
			 * @return {[type]}
			 */
			toSubMenu(data, child, index) {
				this.addLog('button', child + '#2');

				this.$router.push({
					name: 'SecondList',
					params: {
						firstId: data.parent_id,
						secondId: data.child[index]
					}
				})
			},
			toFriendLink(link) {
				this.$router.push({
					path: link
				})
				// window.location.href = link;
			}
		}
	}
</script>
<style lang="scss">
	.admin_wrap {
		background: url(../images/top_bg.jpg) 0 0 / 100% auto no-repeat;
	}
</style>